export const MEDICAL_RECORD = 'MEDICAL_RECORD'
export const SCHEDULE_DETAIL = 'SCHEDULE_DETAIL'

export function setList(list) {
    return {type: MEDICAL_RECORD, list}
}

export function setScheduleDetail(data) {
    return {type: SCHEDULE_DETAIL, data}
}